import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	button: {
		height: "2rem",
		flexShrink: 0,
		justifyContent: "flex-start",
		fontWeight: tokens.fontWeightRegular,
	},
	dialogContent: {
		gridColumn: "span 2",
		"& .ms-Dialog-title": {
			padding: 0,
			minHeight: "10px",
		},
		"& .ms-Dialog-inner": {
			padding: "0 0 24px 0",
		},
	},
	descriptionField: {
		backgroundColor: tokens.colorNeutralBackground4,
		height: "10rem",
		fontSize: tokens.fontSizeBase100,
	},
	descriptionFieldMobile: {
		height: "unset",
	},
	fileInput: {
		display: "none",
	},
	inputField: {
		paddingTop: "20px",
	},
	inputButton: {
		padding: "5px 28px",
		maxWidth: "70%",
	},
	dialogActions: {
		paddingRight: "8px",
	},
});
